// src/pages/misc/public/PublicShell.tsx
// [HANDOFF] PUBLIC SHELL: the frame every simple public page sits in (/como-funciona, /como-funciona/:slug, /preguntas, /contacto).
//   /socios does NOT use it: it needs full-width bands, so it builds the same top bar itself (SociosPage.tsx + landing/useLandingChrome.ts).
//   Layout: the landing's top bar (.vl-topbar.solid, always dark-tinted) with the logo (-> /landing), a gold "Empezar" button (-> /onboarding,
//   hidden under 640px) and the burger that opens LandingMenu; then <main class="pub-main"> (max 760px wide, 1080px with `wide`) holding, in
//   order: kicker (small caps cyan), h1 `title`, lead paragraph, and the page's children.
//   Props: kicker, title, lead, pageTitle (sets the browser tab to "<pageTitle> · Ventaje" and restores it on leave), wide.
//   Background: no background here. The animated ClassicLens is mounted once in App.tsx behind everything.
// [DEPENDS-ON] ../landing/LandingMenu.tsx and ../landing/landing.css (the `.ventaje-landing` class gives the fonts / colors / top bar).
// [URL-RENAME] Links to /landing and /onboarding (both stay in English already; /landing may become / when the landing is swapped in).
// [I18N] The language switch in the menu only changes local state here (`lang`); nothing reads it yet, pages stay Spanish.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import LandingMenu from '../landing/LandingMenu';
import '../landing/landing.css';
import './public.css';

const PublicShell: React.FC<{
  kicker?: string;
  title?: React.ReactNode;
  lead?: string;
  pageTitle?: string;
  wide?: boolean;
  children: React.ReactNode;
}> = ({ kicker, title, lead, pageTitle, wide, children }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [lang, setLang] = useState<'es' | 'en'>('es');

  useEffect(() => {
    const prev = document.title;
    if (pageTitle) document.title = `${pageTitle} · Ventaje`;
    return () => { document.title = prev; };
  }, [pageTitle]);

  return (
    <div className="ventaje-landing pub">
      <header className="vl-topbar solid">
        <Link to="/landing" className="vl-logo">Ventaje</Link>
        <div className="flex items-center gap-2.5">
          <Link
            to="/onboarding"
            className="btn-gold hidden sm:inline-flex items-center justify-center min-h-[44px] px-[22px] rounded-[10px] text-xs font-bold uppercase tracking-[0.1em]"
          >
            Empezar
          </Link>
          <button type="button" className="vl-burger" aria-label="Menú" onClick={() => setMenuOpen(true)}>
            <span /><span /><span />
          </button>
        </div>
      </header>
      <LandingMenu
        open={menuOpen}
        lang={lang}
        onClose={() => setMenuOpen(false)}
        onLang={setLang}
      />
      <main className={`pub-main${wide ? ' is-wide' : ''}`}>
        {kicker ? <p className="pub-kicker">{kicker}</p> : null}
        {title ? <h1>{title}</h1> : null}
        {lead ? <p className="pub-lead">{lead}</p> : null}
        {children}
      </main>
    </div>
  );
};

export default PublicShell;
